import { useEffect, useState } from "react";
import { Wifi, WifiOff, ShieldCheck, LogOut as LogOutIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/ssg-logo.jpeg";
import { useAuth } from "@/hooks/useAuth";

export const Header = ({ connected, onLoginClick }) => {
  const { user, logout } = useAuth();
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <header
      className="sticky top-0 z-40 bg-[#0A192F] text-white border-b-4 border-[#D4AF37] shadow-lg no-print"
      data-testid="app-header"
    >
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <img
            src={logo}
            alt="SSG Sécurité Guinée"
            className="h-12 w-12 sm:h-14 sm:w-14 rounded-md object-contain bg-white/95 p-1 ring-2 ring-[#D4AF37]/60 shrink-0"
            data-testid="app-logo"
          />
          <div className="min-w-0">
            <h1 className="font-serif-title text-base sm:text-xl lg:text-2xl font-bold tracking-wide leading-tight truncate">
              REGISTRE DES VISITEURS
            </h1>
            <p className="text-[10px] sm:text-xs text-[#D4AF37] tracking-[0.2em] uppercase font-semibold">
              SSG · Poste de Sécurité
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 sm:gap-5 shrink-0">
          <div className="hidden sm:flex items-center gap-2 text-xs">
            {connected ? (
              <span className="flex items-center gap-1.5 text-emerald-300" data-testid="sync-status">
                <Wifi className="h-4 w-4" /> Synchro active
              </span>
            ) : (
              <span className="flex items-center gap-1.5 text-amber-300" data-testid="sync-status">
                <WifiOff className="h-4 w-4" /> Reconnexion…
              </span>
            )}
          </div>
          <div className="text-right">
            <div className="font-mono-data text-lg sm:text-2xl font-semibold tabular-nums leading-none">
              {now.toLocaleTimeString("fr-FR")}
            </div>
            <div className="text-[10px] sm:text-xs text-slate-300 capitalize">
              {now.toLocaleDateString("fr-FR", {
                weekday: "long",
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </div>
          </div>

          {user ? (
            <div className="flex items-center gap-2">
              <span className="hidden md:flex items-center gap-1.5 text-xs text-[#D4AF37] font-semibold" data-testid="admin-badge">
                <ShieldCheck className="h-4 w-4" /> {user.name || user.email}
              </span>
              <Button
                size="sm"
                variant="ghost"
                onClick={logout}
                className="text-white hover:bg-white/10 h-9 gap-1.5"
                data-testid="logout-btn"
              >
                <LogOutIcon className="h-4 w-4" /> <span className="hidden sm:inline">Déconnexion</span>
              </Button>
            </div>
          ) : (
            <Button
              size="sm"
              onClick={onLoginClick}
              className="bg-[#D4AF37] hover:bg-[#C59B27] text-[#0A192F] font-semibold h-9 gap-1.5"
              data-testid="admin-login-btn"
            >
              <ShieldCheck className="h-4 w-4" /> <span className="hidden sm:inline">Espace admin</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
